// extracted by mini-css-extract-plugin
export var actions = "_3w-0";
export var actionsContainer = "_3w-6";
export var border = "_3w-1";
export var childFullHeight = "_3w-d";
export var collapse = "_3w-2";
export var content = "_3w-8";
export var contentChild = "_3w-c";
export var fullscreen = "_3w-a";
export var headerContainer = "_3w-3";
export var headerRow = "_3w-5";
export var hidePadding = "_3w-9";
export var noScrollX = "_3w-e";
export var noScrollY = "_3w-f";
export var optOutTopPadding = "_3w-b";
export var pagePadding = "_3w-7";
export var profile = "_3w-g";
export var profileContainer = "_3w-h";
export var profileImage = "_3w-i";
export var profileMain = "_3w-j";
export var profileSubtitle = "_3w-l";
export var profileTitle = "_3w-k";
export var tabsWrapper = "_3w-4";
export var title = "_3w-m";